import React from "react";

const PageNotFound = () => <h1>Ooops! Page not Found</h1>;

export default PageNotFound; 


// WEBPACK FOOTER //
// ./src/components/PageNotFound.js